//id das features de ia, igual ao iaConfiguracaoFeature do back
export enum IaConfiguracaoFeatureEnum {
  TRANSCRICAO_AUDIO = 2,
  APOIO_CHAT = 3,
  SUGESTAO_SOLUCAO_TICKET = 4,
  APOIO_NOVOS_COMENTARIOS = 5,
  APOIO_NOVOS_EMAILS = 6,
  APOIO_BASE_CONHECIMENTO = 7,
  AVALIAR_HISTORICO_CHAT = 8,
  BASE_CONHECIMENTO_TICKET = 9,
  TRANSCRICAO_IMAGEM = 10,
  IA_MILVUS = 11,
  MELHORAR_ORTOGRAFIA_GRAMATICA = 12,
  SUGERIR_TEXTO_INICIO_ATENDIMENTO = 13,
  QUESTOES_ENTENDER_SOLICITACAO = 14,
  TEXTO_FINALIZAR_TICKET = 15,
  POWERSHELL = 16,
  SCRIPTS = 17,
  TOKENIZACAO = 18,
  SENTIMENTO_TICKET = 19,
  CATEGORIZACAO_AUTOMATICA_TICKET = 20,
  RESUMIR_TRANSCRICAO = 21
}
